/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTriangleCircleSquareFill: {
  name: 'triangle-circle-square-fill';
  data: string;
} = {
  name: 'triangle-circle-square-fill',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.447.776a.5.5 0 0 0-.894 0l-3 6A.5.5 0 0 0 5 7.5h6a.5.5 0 0 0 .447-.724l-3-6ZM1 8.5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5H1ZM8.5 12a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
